import { defineComponent, ref } from 'vue';
import CardIcon from '@/components/common/card-icon/index.vue';
import CusHeader from '@/components/common/header/index.vue';
import SelectList from '@/components/common/select-list';
import SharePopup from '@/components/common/share-popup/index.vue';
import { server as serverForCode } from '@/data/common';
import { useRouter } from 'vue-router';
import HttpRequest from '@/util/axios.config';
import TimeTab from '@/components/common/time-tab/index.vue';
import getData, { controlTimeType } from './util';
export default defineComponent({
    components: {
        CardIcon,
        CusHeader,
        SelectList,
        SharePopup,
        TimeTab
    },
    props: {
        type: {
            type: String,
            required: true
        },
        server: {
            type: String,
            required: true
        },
        token: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const { disList, cardInfo } = getData(props.server, props.type, props.token);
        const pageName = ref('');
        const serverList = ref([]);
        const getServerList = () => {
            HttpRequest.get('getConfig', props.token === '' ? {} : {
                Token: props.token
            }, (res) => {
                if (props.token !== '') {
                    pageName.value = res.data.token.Title === '' ? props.type : res.data.token.Title;
                }
                else {
                    pageName.value = res.data.admin.pageName ? res.data.admin.pageName : props.type;
                }
                serverList.value = [{
                        label: 'Global',
                        value: 'global'
                    }];
                if (props.token === '') {
                    res.data.serverList.forEach((item) => {
                        serverList.value.push({
                            label: item.name,
                            value: item.code
                        });
                    });
                }
            });
        };
        getServerList();
        const router = useRouter();
        // 跳转服务器页面
        const goToSeverPage = (server) => {
            if (server === 'global') {
                router.push('/global');
            }
            else {
                router.push(`/server?type=${server}`);
            }
        };
        // 跳转代理商页面
        const goToDisPage = (dis) => {
            router.push(`/dis?type=${dis}&server=${props.server}`);
            getData(props.server, dis, props.token);
            getServerList();
        };
        const showShareDialog = ref(false);
        const shareUrl = `http://120.78.142.208:1717/manage-new/#/dis?type=${props.type}&server=${props.server}&token=`;
        const { timeType, setTimeType } = controlTimeType();
        return {
            disList,
            cardInfo,
            serverList,
            goToSeverPage,
            goToDisPage,
            showShareDialog,
            shareUrl,
            pageName,
            timeType,
            setTimeType,
            serverForCode
        };
    }
});
